module.exports = __webpack_public_path__ + "static/bam-ec9be395bbd5faaef12d3454df6f02fa.png";